import { CurrentHouseProvider } from '@/context/CurrentHouseContext';
import TransferOwnershipGuard from '@/components/settings/pages/TransferOwnershipGuard.tsx';
import {
	TRANSFER_RETURN_TARGETS,
	type TransferReturnTarget,
} from '@/components/settings/pages/TransferOwnershipPage.tsx';
import type React from 'react';

const isTransferReturnTarget = (value: unknown): value is TransferReturnTarget =>
	typeof value === 'string' && TRANSFER_RETURN_TARGETS.includes(value as TransferReturnTarget);

const TransferOwnershipRoute: React.FC = () => {
	const { returnTo } = Route.useSearch();
	const { propertyPublicId } = Route.useParams();

	return (
		<CurrentHouseProvider>
			<TransferOwnershipGuard propertyPublicId={propertyPublicId} returnTo={returnTo} />
		</CurrentHouseProvider>
	);
};

/**
 * Transfer ownership page scoped to a specific property via its public ID in the URL.
 */
export const Route = createFileRoute({
	validateSearch: (search: Record<string, unknown>) => ({
		returnTo: isTransferReturnTarget(search.returnTo) ? search.returnTo : 'settings',
	}),
	component: TransferOwnershipRoute,
});
